import { Expose } from 'class-transformer';

export class RecoverPasswordModel {
  @Expose()
  httpStatusCode: string;
}
